import * as React from 'react';
import { toast } from 'sonner';

import { registrarServiceWorker } from '@/pwa/registro';

/**
 * Registra o service worker e avisa quando há versão nova.
 *
 * O aviso é um convite, não uma troca automática: recarregar sozinho no meio
 * do formulário de solicitação perderia o que a recepção já digitou. Fica
 * aberto até alguém decidir, e a versão nova entra sozinha na próxima vez que
 * o aplicativo for aberto.
 */
export function AtualizacaoDisponivel() {
  React.useEffect(
    () =>
      registrarServiceWorker((aplicar) => {
        toast('Nova versão do KAVI disponível', {
          description: 'Recarregue para usar a versão mais recente.',
          duration: Infinity,
          action: { label: 'Atualizar', onClick: aplicar },
        });
      }),
    [],
  );

  return null;
}
